import { getStoredSessionToken } from "./appleAuth";

export type SeedSchemaResult = {
  schemaVersion: number;
  environment: string;
  written: number;
  recordTypes: string[];
  recordNames: string[];
  seedDateKey: string;
  note: string;
};

export async function seedCloudKitSchema(): Promise<SeedSchemaResult> {
  const token = getStoredSessionToken();
  if (!token) throw new Error("Sign in required.");

  const res = await fetch("/api/seed", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = (await res.json()) as SeedSchemaResult & { error?: string };
  if (!res.ok) throw new Error(data.error ?? `Seed failed (${res.status})`);
  return data;
}
